import { userConstants } from "../constants";
import { userService } from "../services";
import { yodaStakeholderActions } from "../actions";
import { history, jwtDecoder } from "../../utils";
import { PublicClientApplication } from "@azure/msal-browser/dist/index";
import { msalConfig } from "../../utils/authConfig";

export const userActions = {
  login,
  logout,
  updateToken,
  myProfile,
  updateUser,
  changePassword,
  resetPassword,
  getByEmail,
  register,
  activate,
  resetUsersDetails,
  resetMe,
  getMany,
  getAll,
};

function login(username, password, onSuccess) {
  return (dispatch) => {
    dispatch(request());

    userService.login(username, password).then(
      (response) => {
        if (response) {
          dispatch(success(response.token));

          sessionStorage.setItem("token", response.token);
          sessionStorage.setItem("refreshToken", response.refresh_Token);

          dispatch(yodaStakeholderActions.getMe());

          onSuccess && onSuccess();

          history.push("/");
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userConstants.LOGIN_REQUEST };
  }

  function success(token) {
    return {
      type: userConstants.LOGIN_SUCCESS,
      payload: { token, user: jwtDecoder(token) },
    };
  }

  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, payload: { error } };
  }
}

const msalInstance = new PublicClientApplication(msalConfig);
const logoutRequest = {
  account: msalInstance.getActiveAccount(),
};

function logout() {
  return (dispatch) => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(success());
    dispatch(yodaStakeholderActions.reset());

    window.location.replace(msalConfig.auth.postLogoutRedirectUri);
  };

  function success(error) {
    return { type: userConstants.LOGOUT };
  }
}

function updateToken() {
  return (dispatch) => {
    dispatch(request());
    userService.updateToken().then(
      (response) => {
        if (response.success) {
          const { data } = response;

          dispatch(success(data));
          sessionStorage.setItem("token", JSON.stringify(data));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userConstants.UPDATETOKEN_REQUEST };
  }

  function success(token) {
    return {
      type: userConstants.UPDATETOKEN_SUCCESS,
      payload: { token, user: jwtDecoder(token) },
    };
  }

  function failure(error) {
    return { type: userConstants.UPDATETOKEN_FAILURE, payload: { error } };
  }
}

function resetUsersDetails() {
  return { type: userConstants.RESETDETAILS };
}

function resetMe() {
  return { type: userConstants.RESETME };
}

function myProfile(id) {
  return (dispatch, getState) => {
    dispatch(request(id));

    userService.getUsersDetails([id]).then(
      (response) => {
        if (response.success) {
          const { data } = response;

          if (data.length == 0) {
            //history.push("/login");
          } else {
            dispatch(success(data[0]));
          }
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(id) {
    return { type: userConstants.MYPROFILE_REQUEST, payload: { id } };
  }

  function success(user) {
    return { type: userConstants.MYPROFILE_SUCCESS, payload: { user } };
  }

  function failure(error) {
    return { type: userConstants.MYPROFILE_FAILURE, payload: { error } };
  }
}

function getMany(ids) {
  return (dispatch, getState) => {
    dispatch(request(ids));

    userService.getUsersDetails(ids).then(
      (response) => {
        if (response.success) {
          const { data } = response;
          dispatch(success(ids, data));
        } else {
          dispatch(failure(ids, response));
        }
      },
      (error) => {
        dispatch(failure(ids, error));
      },
    );
  };

  function request(ids) {
    return { type: userConstants.GETDETAILS_REQUEST, payload: { ids } };
  }

  function success(ids, users) {
    return { type: userConstants.GETDETAILS_SUCCESS, payload: { ids, users } };
  }

  function failure(ids, error) {
    return { type: userConstants.GETDETAILS_FAILURE, payload: { ids, error } };
  }
}

function updateUser(id, user) {
  return (dispatch, getState) => {
    dispatch(request(id, user));

    if (user.Address) {
      user.Address.GeoLocation = null;
    }

    userService.updateUser(id, user).then(
      (response) => {
        if (response.success) {
          const { data } = response;
          dispatch(success(id, data));

          const { me } = getState().users;

          if (me.Id === id) {
            dispatch(this.updateToken(getState().authentication.user.siteId));
          }
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(id, user) {
    return { type: userConstants.UPDATE_REQUEST, payload: { id, user } };
  }

  function success(id, user) {
    return { type: userConstants.UPDATE_SUCCESS, payload: { id, user } };
  }

  function failure(error) {
    return { type: userConstants.UPDATE_FAILURE, payload: { error } };
  }
}

function changePassword(id, email, currentPassword, newPassword) {
  return (dispatch) => {
    dispatch(request());

    const obj = {
      Id: id,
      Email: email,
      CurrentPassword: currentPassword,
      NewPassword: newPassword,
    };

    userService.changePassword(id, obj).then(
      (response) => {
        if (response.success) {
          dispatch(success());
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userConstants.CHANGEPASSWORD_REQUEST };
  }

  function success() {
    return { type: userConstants.CHANGEPASSWORD_SUCCESS };
  }

  function failure(error) {
    return { type: userConstants.CHANGEPASSWORD_FAILURE, payload: { error } };
  }
}

function resetPassword(email) {
  return (dispatch) => {
    dispatch(request(email));

    const obj = {
      Email: email,
    };

    userService.resetPassword(obj).then(
      (response) => {
        if (response.success) {
          dispatch(success(email));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(email) {
    return { type: userConstants.RESETPASSWORD_REQUEST, payload: { email } };
  }

  function success(email) {
    return { type: userConstants.RESETPASSWORD_SUCCESS, payload: { email } };
  }

  function failure(error) {
    return { type: userConstants.RESETPASSWORD_FAILURE, payload: { error } };
  }
}

function getByEmail(email) {
  return (dispatch) => {
    dispatch(request(email));

    userService.getByEmail(email).then(
      (response) => {
        if (response.success) {
          const { data } = response;
          dispatch(success(email, data));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(id) {
    return { type: userConstants.GETBYEMAIL_REQUEST, payload: { id } };
  }

  function success(email, user) {
    return { type: userConstants.GETBYEMAIL_SUCCESS, payload: { email, user } };
  }

  function failure(error) {
    return { type: userConstants.GETBYEMAIL_FAILURE, payload: { error } };
  }
}

function register(email, name) {
  return (dispatch) => {
    dispatch(request(email, name));

    const registrationModel = {
      Email: email,
      Name: name,
      ExternalProvider: null,
    };
    userService.register(registrationModel).then(
      (response) => {
        if (response.success) {
          dispatch(success(response.data));
        } else {
          dispatch(failure(response.message));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(email, name) {
    return { type: userConstants.REGISTER_REQUEST, payload: { email, name } };
  }

  function success(data) {
    return { type: userConstants.REGISTER_SUCCESS, payload: { data } };
  }

  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, payload: { error } };
  }
}

function activate(secret, user) {
  return (dispatch) => {
    const {
      name,
      licence,
      subscription,
      password,
      address,
      companyName,
      vatId,
    } = user;
    dispatch(request(secret, name, password, licence));

    /*const registrationModel = {
            Name: name,
            Licence: licence,
            Subscription: subscription,
            Password: password,
            Address: address,
            CompanyName: companyName,
            VatId: vatId,
        };*/

    userService.activate(user, secret).then(
      (response) => {
        if (response.success) {
          dispatch(success(response.data));
          history.push("/login");
        } else {
          dispatch(failure());
          history.push("/login");
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(secret, name, licence) {
    return {
      type: userConstants.ACTIVATE_REQUEST,
      payload: { secret, name, licence },
    };
  }

  function success(data) {
    return { type: userConstants.ACTIVATE_SUCCESS, payload: { data } };
  }

  function failure() {
    return { type: userConstants.ACTIVATE_FAILURE };
  }
}

function setupIntent() {
  return (dispatch) => {
    dispatch(request());

    userService.setupIntent().then(
      (response) => {
        if (response.success) {
          dispatch(success(response.data));
        } else {
          dispatch(failure());
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userConstants.SETUPINTENT_REQUEST, payload: {} };
  }

  function success(secret) {
    return { type: userConstants.SETUPINTENT_SUCCESS, payload: { secret } };
  }

  function failure() {
    return { type: userConstants.SETUPINTENT_FAILURE, payload: {} };
  }
}

/**
 * Get the list of all users
 */
function getAll() {
  return (dispatch) => {
    dispatch(request());

    userService.getAll().then(
      (response) => {
        if (response.success) {
          const { data } = response;
          dispatch(success(data));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }

  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, payload: { users } };
  }

  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, payload: { error } };
  }
}
